import { Controller } from "@hotwired/stimulus"

const FA_DIGITS = "۰۱۲۳۴۵۶۷۸۹"

// Estimates profit for a given investment amount on a plan's show page,
// based on the plan's participation profit rate, payout interval and
// participation duration (passed in as data-*-value attributes). Purely
// illustrative — the authoritative schedule is the contract's, computed
// server-side at settlement.
export default class extends Controller {
  static targets = ["amount", "result", "totalProfit", "totalReturn"]
  static values = { rate: Number, intervalMonths: Number, durationMonths: Number }

  connect() {
    this.calculate()
  }

  onInput() {
    const amount = this.parseAmount(this.amountTarget.value)
    this.amountTarget.value = amount ? this.formatFa(amount) : ""
    this.calculate()
  }

  calculate() {
    const amount = this.parseAmount(this.amountTarget.value)
    const intervalProfit = amount * (this.rateValue / 100) * (this.intervalMonthsValue / 12)
    this.resultTarget.textContent = this.formatFa(Math.round(intervalProfit))

    const duration = this.durationMonthsValue || this.intervalMonthsValue
    const totalProfit = amount * (this.rateValue / 100) * (duration / 12)
    if (this.hasTotalProfitTarget) {
      this.totalProfitTarget.textContent = this.formatFa(Math.round(totalProfit))
    }
    if (this.hasTotalReturnTarget) {
      this.totalReturnTarget.textContent = this.formatFa(Math.round(amount + totalProfit))
    }
  }

  parseAmount(raw) {
    const digits = this.toEnDigits(raw).replace(/[^\d]/g, "")
    return digits ? parseInt(digits, 10) : 0
  }

  // Input starts pre-filled with a fa_amount()-formatted value (Persian
  // digits + "٬" delimiters), and users may keep typing Persian digits —
  // JS's \d only matches ASCII 0-9, so these must be normalized first.
  toEnDigits(value) {
    return value.replace(/[۰-۹]/g, (digit) => String(FA_DIGITS.indexOf(digit)))
  }

  formatFa(value) {
    const withDelimiters = value.toLocaleString("en-US").replaceAll(",", "٬")
    return withDelimiters.replace(/[0-9]/g, (digit) => FA_DIGITS[digit])
  }
}
